import './App.css';
import { useEffect, useState, useCallback } from "react";

function ResaMobile({ token }) {
  // --- States ---
  const [reservations, setReservations] = useState([]);
  const [businessExpenses, setBusinessExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");


 

  const API_URL = process.env.REACT_APP_API_URL; // change selon ton backend

  // --- Fetch Reservations ---
  const fetchReservations = useCallback(async () => {
    const res = await fetch(`${API_URL}/reservation`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    const data = await res.json();
    // tri décroissant par date
    const sortedData = data.sort((a, b) => new Date(b.start_date) - new Date(a.end_date));
    setReservations(sortedData);
  }, [token, API_URL]);

  // --- Fetch Business Expenses ---
  const fetchBusinessExpenses = useCallback(async () => {
    const res = await fetch(`${API_URL}/business_expense`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    const data = await res.json();
    // tri décroissant par date
    const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));
    setBusinessExpenses(sortedData);
  }, [token, API_URL]);

  const filteredReservations = reservations.filter(r => {
    if (!startDate && !endDate) return true;
    const date = new Date(r.start_date);
    if (startDate && date < new Date(startDate)) return false;
    if (endDate && date > new Date(endDate)) return false;
    return true;
  });
  
  const filteredBusinessExpenses = businessExpenses.filter(b => {
    if (!startDate && !endDate) return true;
    const date = new Date(b.date);
    if (startDate && date < new Date(startDate)) return false;
    if (endDate && date > new Date(endDate)) return false;
    return true;
  });

   // --- Totaux ---
   const totalReservations = filteredReservations.reduce((sum, r) => sum + (Number(r.income) || 0), 0);
   const totalBusinessExpenses = filteredBusinessExpenses.reduce((sum, e) => sum + (Number(e.value) || 0), 0);
   const netTotal = totalReservations - totalBusinessExpenses;
 

  // --- Load Data ---
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await fetchReservations();
      await fetchBusinessExpenses();
      setLoading(false);
    };
    load();
  }, [fetchReservations, fetchBusinessExpenses]);

 





  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <div className="p-4 sm:p-6 bg-gray-100 min-h-screen space-y-8">
      {/* --- Filtres par dates --- */}
      <div className="bg-white p-4 rounded-xl shadow-md">
        <h2 className="text-lg font-bold mb-3 text-center sm:text-left">
          Filtrer par dates
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center sm:justify-start">
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">Date de début</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="border p-2 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">Date de fin</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="border p-2 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
            />
          </div>
        </div>
      </div>

      {/* --- Totaux --- */}
      <div className="bg-white p-4 sm:p-6 rounded-xl shadow-md flex flex-col sm:flex-row justify-around text-center gap-4">
        <div>
          <h3 className="text-lg font-bold text-green-600">Total Reservations</h3>
          <p className="text-2xl font-semibold">{totalReservations.toFixed(2)} MAD</p>
        </div>
        <div>
          <h3 className="text-lg font-bold text-red-600">Total Business Expenses</h3>
          <p className="text-2xl font-semibold">{totalBusinessExpenses.toFixed(2)} MAD</p>
        </div>
        <div>
          <h3 className="text-lg font-bold text-blue-600">Net</h3>
          <p className="text-2xl font-semibold">{netTotal.toFixed(2)} MAD</p>
        </div>
      </div>

      {/* --- Reservations --- */}
      <div className="bg-white p-4 rounded-xl shadow-md">
        <h2 className="text-xl font-bold mb-4">Reservations</h2>

        {/* --- Cartes sur mobile --- */}
        <div className="grid sm:hidden gap-3">
          {filteredReservations.map((res) => (
            <div
              key={res._id}
              className="border rounded-xl p-3 bg-blue-50 shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex justify-between">
                <span className="font-semibold">{res.name}</span>
                <span className="text-green-700 font-bold">{res.income} MAD</span>
              </div>
              <div className="text-sm text-gray-600 mt-2 space-y-1">
                <p>📅 {new Date(res.start_date).toLocaleDateString()} → {new Date(res.end_date).toLocaleDateString()}</p>
                <p>🏷️ Plateforme : <span className="font-medium">{res.platform}</span></p>
                <p>💰 Payée : {res.is_payed ? "✅ Oui" : "❌ Non"}</p>
              </div>
            </div>
          ))}
        </div>

        {/* --- Tableau sur desktop --- */}
        <table className="hidden sm:table w-full table-auto border-collapse border">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-2 py-1">Name</th>
              <th className="border px-2 py-1">Platform</th>
              <th className="border px-2 py-1">Income</th>
              <th className="border px-2 py-1">Start</th>
              <th className="border px-2 py-1">End</th>
              <th className="border px-2 py-1">Payed?</th>
            </tr>
          </thead>
          <tbody>
            {filteredReservations.map((res) => (
              <tr key={res._id}>
                <td className="border px-2 py-1">{res.name}</td>
                <td className="border px-2 py-1">{res.platform}</td>
                <td className="border px-2 py-1">{res.income}</td>
                <td className="border px-2 py-1">
                  {new Date(res.start_date).toLocaleDateString()}
                </td>
                <td className="border px-2 py-1">
                  {new Date(res.end_date).toLocaleDateString()}
                </td>
                <td className="border px-2 py-1">{res.is_payed ? "Yes" : "No"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* --- Business Expenses --- */}
      <div className="bg-white p-4 rounded-xl shadow-md">
        <h2 className="text-xl font-bold mb-4">Business Expenses</h2>

        {/* --- Cartes sur mobile --- */}
        <div className="grid sm:hidden gap-3">
          {filteredBusinessExpenses.map((bexp) => (
            <div
              key={bexp._id}
              className="border rounded-xl p-3 bg-red-50 shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex justify-between">
                <span className="font-semibold">{bexp.name}</span>
                <span className="text-red-700 font-bold">{bexp.value} MAD</span>
              </div>
              <div className="text-sm text-gray-600 mt-2 space-y-1">
                <p>📅 {new Date(bexp.date).toLocaleDateString()}</p>
                <p>💰 Payée : {bexp.is_payed ? "✅ Oui" : "❌ Non"}</p>
              </div>
            </div>
          ))}
        </div>

        {/* --- Tableau sur desktop --- */}
        <table className="hidden sm:table w-full table-auto border-collapse border">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-2 py-1">Name</th>
              <th className="border px-2 py-1">Value</th>
              <th className="border px-2 py-1">Date</th>
              <th className="border px-2 py-1">Payed?</th>
            </tr>
          </thead>
          <tbody>
            {filteredBusinessExpenses.map((bexp) => (
              <tr key={bexp._id}>
                <td className="border px-2 py-1">{bexp.name}</td>
                <td className="border px-2 py-1">{bexp.value}</td>
                <td className="border px-2 py-1">
                  {new Date(bexp.date).toLocaleDateString()}
                </td>
                <td className="border px-2 py-1">{bexp.is_payed ? "Yes" : "No"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  );
}

export default ResaMobile;
